import React from "react";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * <EmptyState /> — the "nothing here yet" surface.
 * Premium feel: big glowing icon halo, generous whitespace, clear CTA.
 */
export default function EmptyState({
  icon: Icon = Sparkles,
  title,
  subtitle,
  action = null,
  testId,
  className,
  tone = "primary",  // "primary" | "muted"
}) {
  const halo =
    tone === "muted"
      ? "bg-gradient-to-br from-muted to-muted/60 text-muted-foreground"
      : "bg-gradient-to-br from-primary/20 to-primary/5 text-primary";
  const ring =
    tone === "muted"
      ? "before:bg-muted/40"
      : "before:bg-primary/10";
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center px-6 py-14 impo-in",
        className,
      )}
      data-testid={testId || "empty-state"}
    >
      {/* Icon w/ soft glowing halo behind it */}
      <div className="relative mb-4">
        <div
          className={cn(
            "absolute inset-0 -m-4 rounded-full blur-2xl opacity-70",
            ring.replace("before:", ""),
          )}
          aria-hidden
        />
        <div className={cn(
          "relative h-16 w-16 rounded-2xl flex items-center justify-center",
          halo,
          "shadow-[0_10px_28px_-8px_hsl(var(--primary)/0.35)]",
        )}>
          <Icon className="h-7 w-7" strokeWidth={1.8} />
        </div>
      </div>
      <div className="font-display font-semibold text-lg leading-tight">{title}</div>
      {subtitle && (
        <div className="text-sm text-muted-foreground max-w-[280px] mt-1.5 leading-relaxed">
          {subtitle}
        </div>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
